import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { SketchPicker } from "react-color";
import Card from "@material-ui/core/Card";
import MenuItem from "@material-ui/core/MenuItem";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import LinearProgress from "@material-ui/core/LinearProgress";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Sidebar from "../../components/Sidebar";
import { AuthContext } from "../../context/AuthContext";

const useStyle = makeStyles({
  fieldWrapper: {
    display: "flex",
    marginBottom: 30,
  },
  fieldName: {
    flexGrow: 1,
    marginTop: 11,
    width: 100,
  },
  fieldInput: {
    flexGrow: 3,
    width: 200,
  },
  input: {
    padding: "5px",
    height: 45,
    borderRadius: 15,
  },
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
    padding: "5px",
    height: 45,
    borderRadius: 15,
  },
  margin: {
    marginBottom: 20,
  },
  textarea: {
    borderRadius: 15,
  },
  buttonStyle: {
    padding: " 10px 30px",
    fontSize: 14,
    borderRadius: "25px",
    marginLeft: 20,
  },
  buttonWeraper: {
    marginTop: 25,
    float: "right",
  },
  styleCancel: {
    color: "#999",
  },
  padding: {
    padding: 30,
  },
  label: {
    backgroundColor: "indigo",
    color: "white",
    padding: "0.5rem",
    borderRadius: "0.3rem",
    cursor: "pointer",
    marginTop: "1rem",
  },
});

const CreateOffer = () => {
  const classes = useStyle();
  const history = useHistory();
  const [title, set_title] = useState("");
  const [brand_name, set_brand_name] = useState("");
  const [brand_logo, set_brand_logo] = useState("");
  const [details, set_details] = useState("");
  const [forward_to_id, set_forward_to_id] = useState("");
  const [submitType, setSubmitType] = useState("");
  const [is_deal, set_is_deal] = useState(false);

  const [is_bundle_offer, set_is_bundle_offer] = useState(false);
  const [operators, set_oparators] = useState([]);
  const [operator, set_oparator] = useState("");
  const [bundle_offers, set_bundle_offers] = useState([]);
  const [bundle_offer, set_bundle_offer] = useState("");
  const [link, set_link] = useState("");
  const [btn_text, set_btn_text] = useState("");
  const [btn_color, set_btn_color] = useState("");
  const [visiableColor, setVisiableColor] = useState(false);

  const [categories, setCategories] = useState([]);
  const [attachment, set_attachment] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileName2, setFileName2] = useState("");

  const { auth, logout } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("is deal offer: ", is_deal);
    setLoading(true);

    try {
      const data = new FormData();
      if (attachment) {
        const imagedata = attachment;
        data.append("banner", imagedata);
      }
      if (brand_logo) {
        const imagedata2 = brand_logo;
        data.append("brand_logo", imagedata2);
      }
      data.append("title", title);
      data.append("brand_name", brand_name);
      data.append("details", details);
      data.append("link", link);

      let res = await axios({
        url: "/api/offers",
        method: "post",
        data: data,
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
          type: "formData",
        },
      });

      if (res.data.code === 200) {
        Swal.fire({
          icon: "success",
          title: "Successfully Saved",
          showConfirmButton: false,
          timer: 1000,
        });
        if (submitType === "addAnother") {
          set_title("");
          set_brand_name("");
          set_details("");
          set_attachment(null);
          set_brand_logo(null);
          set_link("");
          setFileName("");
          setFileName2("");
          setRefresh(!refresh);
        } else if (submitType === "add") {
          history.push("/offer-list");
        }
      } else {
        Swal.fire({
          icon: "warning",
          title: res.data.messages,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "warning",
        title: `${error.response.data.messages.toString()}`,
        showConfirmButton: false,
        timer: 2000,
      });
    }
    setLoading(false);
  };

  const handleCancel = () => {
    history.push("/offer-list");
  };

  const imageButton = () => {
    const actualBtn = document.getElementById("actual-btn");
    const actualBtn2 = document.getElementById("actual-btn2");

    const fileChosen = document.getElementById("file-chosen");
    const fileChosen2 = document.getElementById("file-chosen2");

    actualBtn.addEventListener("change", function () {
      fileChosen.textContent = this.files[0].name;
      setFileName(this.files[0].name);
    });

    actualBtn2.addEventListener("change", function () {
      fileChosen2.textContent = this.files[0].name;
      setFileName2(this.files[0].name);
    });
  };

  useEffect(() => {
    imageButton();
  }, [refresh]);

  return (
    <div className="wrapper">
      <Sidebar />
      <div className="wrapper-inner">
        <form onSubmit={handleSubmit}>
          <Grid container>
            <Grid item md={10} lg={8}>
              <Typography variant="h4" className={classes.margin}>
                Create Offer
              </Typography>
              <Card>
                <CardContent className={classes.padding}>
                  <div className={classes.fieldWrapper}>
                    <div className={classes.fieldName}>
                      <Typography variant="subtitle1">Title</Typography>
                    </div>
                    <div className={classes.fieldInput}>
                      <TextField
                        required
                        placeholder="E.g. Marketing Manager"
                        variant="outlined"
                        fullWidth
                        value={title}
                        onChange={(e) => set_title(e.target.value)}
                        InputProps={{
                          className: classes.input,
                        }}
                      />
                    </div>
                  </div>
                  <div className={classes.fieldWrapper}>
                    <div className={classes.fieldName}>
                      <Typography variant="subtitle1">Brand Name</Typography>
                    </div>
                    <div className={classes.fieldInput}>
                      <TextField
                        required
                        placeholder="Enter your brand name"
                        variant="outlined"
                        fullWidth
                        value={brand_name}
                        onChange={(e) => set_brand_name(e.target.value)}
                        InputProps={{
                          className: classes.input,
                        }}
                      />
                    </div>
                  </div>
                  <div className={classes.fieldWrapper}>
                    <div className={classes.fieldName}>
                      <Typography variant="subtitle1">Brand Logo</Typography>
                    </div>

                    <div className={classes.fieldInput}>
                      <input
                        type="file"
                        id="actual-btn2"
                        accept="image/png, image/jpeg"
                        hidden
                        onChange={(e) => set_brand_logo(e.target.files[0])}
                        name="brand_logo"
                      />
                      <label htmlFor="actual-btn2">
                        <Button
                          variant="contained"
                          color="primary"
                          component="span"
                          className={classes.buttonStyle}
                          style={{ marginLeft: "-0px" }}
                        >
                          Choose file
                        </Button>
                      </label>
                      <span id="file-chosen2" style={{ marginLeft: 15 }}>
                        {fileName2 ? fileName2 : "No file chosen"}
                      </span>
                    </div>
                  </div>
                  <div className={classes.fieldWrapper}>
                    <div className={classes.fieldName}>
                      <Typography variant="subtitle1">Banner </Typography>
                    </div>

                    <div className={classes.fieldInput}>
                      <input
                        type="file"
                        id="actual-btn"
                        accept="image/png, image/jpeg"
                        hidden
                        onChange={(e) => set_attachment(e.target.files[0])}
                        name="attachment"
                      />
                      <label htmlFor="actual-btn">
                        <Button
                          variant="contained"
                          color="primary"
                          component="span"
                          className={classes.buttonStyle}
                          style={{ marginLeft: "-0px" }}
                        >
                          Choose file
                        </Button>
                      </label>
                      <span id="file-chosen" style={{ marginLeft: 15 }}>
                        {fileName ? fileName : "No file chosen"}
                      </span>
                    </div>
                  </div>
                  <div className={classes.fieldWrapper}>
                    <div className={classes.fieldName}>
                      <Typography variant="subtitle1">Details</Typography>
                    </div>
                    <div className={classes.fieldInput}>
                      <TextField
                        required
                        variant="outlined"
                        placeholder="Details"
                        multiline
                        rcurrenciesows={7}
                        rows={5}
                        fullWidth
                        value={details}
                        onChange={(e) => set_details(e.target.value)}
                        InputProps={{
                          className: classes.textarea,
                        }}
                      />
                    </div>
                  </div>

                  <div className={classes.fieldWrapper}>
                    <div className={classes.fieldName}>
                      <Typography variant="subtitle1">Link</Typography>
                    </div>
                    <div className={classes.fieldInput}>
                      <TextField
                        required
                        variant="outlined"
                        placeholder="https://example.com"
                        fullWidth
                        type="url"
                        value={link}
                        onChange={(e) => set_link(e.target.value)}
                        InputProps={{
                          className: classes.input,
                        }}
                      />
                    </div>
                  </div>

                  {/* <div className={classes.fieldWrapper}>
                    <div className={classes.fieldName}>
                      <Typography variant="subtitle1">Forward to</Typography>
                    </div>
                    <div className={classes.fieldInput}>
                      <TextField
                        id="outlined-select-currency"
                        select
                        required
                        onChange={(e) => set_forward_to_id(e.target.value)}
                        variant="outlined"
                        fullWidth
                        value={forward_to_id}
                        InputProps={{
                          className: classes.select,
                        }}
                      >
                        {categories.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </div>
                  </div> */}

                  {/* <div className={classes.fieldWrapper}>
                    <div className={classes.fieldName}>
                      <Typography variant="subtitle1">Is Deal Offer</Typography>
                    </div>
                    <div className={classes.fieldInput}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={is_deal}
                            onChange={(e) => set_is_deal(e.target.checked)}
                            name="is_deal"
                          />
                        }
                        label="Deal Offer"
                      />

                     
                    </div>
                  </div> */}

                  {/* <div className={classes.fieldWrapper}>
                      <div className={classes.fieldName}>
                        <Typography variant="subtitle1">
                          Is Bundle Offer
                        </Typography>
                      </div>
                      <div className={classes.fieldInput}>
                        <Checkbox
                          onChange={handleIsBundle}
                          color="primary"
                          name="Is Bundle Offeer"
                          checked={is_bundle_offer}
                          value={is_bundle_offer}
                        />
                      </div>
                    </div> */}
                  {/* {is_bundle_offer ? (
                    <>
                      <div className={classes.fieldWrapper}>
                        <div className={classes.fieldName}>
                          <Typography variant="subtitle1">Link</Typography>
                        </div>
                        <div className={classes.fieldInput}>
                          <TextField
                            placeholder="Link"
                            variant="outlined"
                            fullWidth
                            value={link}
                            onChange={(e) => set_link(e.target.value)}
                            InputProps={{
                              className: classes.input,
                            }}
                          />
                        </div>
                      </div>

                      <div className={classes.fieldWrapper}>
                        <div className={classes.fieldName}>
                          <Typography variant="subtitle1">
                            Button Text
                          </Typography>
                        </div>
                        <div className={classes.fieldInput}>
                          <TextField
                            placeholder="Button Text"
                            variant="outlined"
                            fullWidth
                            value={btn_text}
                            onChange={(e) => set_btn_text(e.target.value)}
                            InputProps={{
                              className: classes.input,
                            }}
                          />
                        </div>
                      </div>

                      <div className={classes.fieldWrapper}>
                        <div className={classes.fieldName}>
                          <Typography variant="subtitle1">
                            Button Color
                          </Typography>
                        </div>
                        <div className={classes.fieldInput}>
                          {visiableColor ? (
                            <SketchPicker
                              color={btn_color}
                              onChangeComplete={handleBtnColor}
                            />
                          ) : (
                            <Button
                              onClick={touglePicker}
                              color="primary"
                              variant="outlined"
                              className={classes.buttonStyle}
                              style={{ marginLeft: 0 }}
                            >
                              Choose Color
                            </Button>
                          )}

                         
                        </div>
                      </div>

                      <div className={classes.fieldWrapper}>
                        <div className={classes.fieldName}>
                          <Typography variant="subtitle1">Operator</Typography>
                        </div>
                        <div className={classes.fieldInput}>
                          <TextField
                            id="outlined-select-currency"
                            select
                            onChange={handleOperaptor}
                            variant="outlined"
                            fullWidth
                            value={operator}
                            InputProps={{
                              className: classes.select,
                            }}
                          >
                            {operators.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                <img
                                  style={{ marginRight: 15 }}
                                  src={option.logo}
                                  height="15px"
                                  alt=""
                                />{" "}
                                {option.name}
                              </MenuItem>
                            ))}
                          </TextField>
                        </div>
                      </div>
                      {operator ? (
                        <div className={classes.fieldWrapper}>
                          <div className={classes.fieldName}>
                            <Typography variant="subtitle1">
                              Bundle Offer
                            </Typography>
                          </div>
                          <div className={classes.fieldInput}>
                            <TextField
                              id="outlined-select-currency"
                              select
                              onChange={handleBundleOffer}
                              variant="outlined"
                              fullWidth
                              value={bundle_offer}
                              InputProps={{
                                className: classes.select,
                              }}
                            >
                              {bundle_offers.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                  <img
                                    style={{ marginRight: 15 }}
                                    src={option.logo}
                                    height="15px"
                                    alt=""
                                  />{" "}
                                  {option.name}
                                </MenuItem>
                              ))}
                            </TextField>
                          </div>
                        </div>
                      ) : null}
                    </>
                  ) : null} */}
                </CardContent>
              </Card>
              {loading ? (
                <LinearProgress style={{ marginTop: 20 }} />
              ) : (
                <div className={classes.buttonWeraper}>
                  <Button
                    onClick={handleCancel}
                    className={classes.styleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="large"
                    type="submit"
                    className={classes.buttonStyle}
                    onClick={(e) => setSubmitType("addAnother")}
                  >
                    Create & Add Another
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    type="submit"
                    className={classes.buttonStyle}
                    onClick={(e) => setSubmitType("add")}
                  >
                    Create Promotional Offer
                  </Button>
                </div>
              )}
            </Grid>
          </Grid>
        </form>
      </div>
    </div>
  );
};

export default CreateOffer;
